export const UNKNOWN = 'unknown';
export const CALENDAR_DATE = 'calendarDate';